<template>
    <span>
        <template v-for="(line, l) in lines" :key="l">
            <br v-if="l > 0">
            <template v-for="(part, p) in line" :key="p">
                <span v-if="part.bold" class="bold">{{ part.text }}</span>
                <template v-else>{{ part.text }}</template>
            </template>
        </template>
    </span>
</template>

<script setup>
// Server and translation text with its little markup (<span class='bold'>, <br/>) shown as text, never as HTML.
// Use this instead of v-html for anything a player's name can end up in: see dod/helpers/dmarkup.mjs.
import { computed, defineProps } from 'vue';
import { parseMarkup, fillPlaceholders } from '@/dod/helpers/dmarkup.mjs';

const props = defineProps({
    text: { type: [String, Number], default: "" },
    values: { type: Object, default: null } // {{KEY}} replacements, filled in after parsing so a value is always text
});

const lines = computed(() => fillPlaceholders(parseMarkup(props.text), props.values));
</script>
